import React from "react";
import { Button, Text } from "@mantine/core";

function FloorSelection({
  data,
  selectedFloor,
  setSelectedFloor,
  setDrawnItems,
  activeFloors,
}) {
  // console.log("selectedFloor :>> ", selectedFloor);
  return (
    <div className={`cc-floor ${window.appSettings?.frontend === "true" && 'cc-floor--light'}`}>
      <Text className="cc-floor__text" size="lg">
        {selectedFloor.name}
      </Text>
      <div className="cc-floor__buttons">
        {data.map((elem, index) => {
          let active = false;
          for (var i = 0; i < activeFloors.length; i++) {
            if (elem.id === activeFloors[i].id) {
              active = true;
              break;
            }
          }

          let currentFloor = false;
          if (selectedFloor.id === elem.id) {
            currentFloor = true;
          }

          return (
            <Button
              key={index}
              className={`cc-floor__button ${
                currentFloor ? "cc-floor__button--current" : active ? "cc-floor__button--active" : ""
              }`}
              variant="subtle"
              radius="xs"
              size="lg"
              onClick={() => {
                setSelectedFloor(elem);
                setDrawnItems(
                  elem.map_settings.coordinates !== null
                    ? elem.map_settings.coordinates
                    : []
                );
              }}
            >
              {index.toString()}
            </Button>
            // hardcoded for when floors start with 0. stāvs
          );
        })}
      </div>
    </div>
  );
}

export default FloorSelection;
